import { Departamento, Usuario, Tarefa, Atividade, Estatisticas, TipoUsuario, Coluna, Quadro } from '../types';

// Dados mockados de departamentos
export const departamentos: Departamento[] = [
  // ... departamentos existentes
];

// Dados mockados de usuários
export const usuarios: Usuario[] = [
  // ... usuários existentes
];

// Usuário logado atual (para simulação)
export const getUsuarioLogado = (): Usuario => {
  // Tentar obter o usuário do localStorage primeiro
  const usuarioSalvo = localStorage.getItem('bravobet_usuario');
  if (usuarioSalvo) {
    try {
      return JSON.parse(usuarioSalvo);
    } catch (error) {
      console.error('Erro ao carregar usuário do localStorage:', error);
    }
  }
  // Fallback para o primeiro usuário se não houver usuário no localStorage
  return usuarios[0];
};

// Para compatibilidade com código existente
export const usuarioLogado: Usuario = usuarios[0];

// Dados mockados de tarefas
const tarefas: Tarefa[] = [
  // ... tarefas existentes
];

// Definição das colunas para tarefas recebidas (onde você é responsável)
export const colunasRecebidas: Coluna[] = [
  {
    id: 'pendente',
    titulo: 'Pendente',
    tarefas: tarefas.filter(tarefa => ['Pendente', 'Solicitado'].includes(tarefa.status)),
    cor: '#3498db',
    statusPermitidos: ['Pendente', 'Solicitado']
  },
  {
    id: 'aIniciar',
    titulo: 'A iniciar',
    tarefas: [],
    cor: '#1abc9c',
    statusPermitidos: ['A iniciar']
  },
  {
    id: 'emAndamento',
    titulo: 'Em Andamento',
    tarefas: tarefas.filter(tarefa => ['Em Andamento', 'Em Execução'].includes(tarefa.status)),
    cor: '#e67e22',
    statusPermitidos: ['Em Andamento', 'Em Execução']
  },
  {
    id: 'concluida',
    titulo: 'Concluída',
    tarefas: tarefas.filter(tarefa => ['Concluída', 'Finalizada'].includes(tarefa.status)),
    cor: '#2ecc71',
    statusPermitidos: ['Concluída', 'Finalizada']
  }
];

// Definição das colunas para tarefas enviadas (onde você é criador)
export const colunasEnviadas: Coluna[] = [
  {
    id: 'pendente',
    titulo: 'Pendente',
    tarefas: tarefas.filter(tarefa => ['Pendente', 'Solicitado'].includes(tarefa.status)),
    cor: '#3498db',
    statusPermitidos: ['Pendente', 'Solicitado']
  },
  {
    id: 'aIniciar',
    titulo: 'A iniciar',
    tarefas: [],
    cor: '#1abc9c',
    statusPermitidos: ['A iniciar']
  },
  {
    id: 'emExecucao',
    titulo: 'Em Execução',
    tarefas: tarefas.filter(tarefa => ['Em Andamento', 'Em Execução'].includes(tarefa.status)),
    cor: '#e67e22',
    statusPermitidos: ['Em Andamento', 'Em Execução']
  },
  {
    id: 'finalizada',
    titulo: 'Finalizada',
    tarefas: tarefas.filter(tarefa => ['Finalizada', 'Concluída'].includes(tarefa.status)),
    cor: '#2ecc71',
    statusPermitidos: ['Finalizada', 'Concluída']
  }
];

// Manter a variável colunas para compatibilidade com o código existente
export const colunas: Coluna[] = colunasRecebidas;

// Definição do quadro Kanban
export const quadroKanban: Quadro = {
  id: 'quadro-1',
  titulo: 'Tarefas Recebidas',
  colunas: colunasRecebidas
};

// Dados mockados de atividades para o usuário logado
export const atividadesUsuarioLogado: Atividade[] = [
  {
    id: 'ativ-1',
    tipo: 'nova_tarefa',
    titulo: 'Nova tarefa atribuída',
    descricao: 'Você recebeu uma nova tarefa: Relatório financeiro mensal',
    tarefa_id: 'tarefa-1',
    tarefa_titulo: 'Relatório financeiro mensal',
    usuario_origem_id: 'user-2',
    usuario_origem_nome: 'Maria Silva',
    usuario_origem_avatar: '/profilepicture.png', // Usando imagem padrão
    data_hora: new Date(Date.now() - 3600000).toISOString(), // 1 hora atrás
    lida: false
  },
  {
    id: 'ativ-2',
    tipo: 'comentario',
    titulo: 'Novo comentário',
    descricao: 'Maria comentou na tarefa: Precisamos finalizar isso até amanhã',
    tarefa_id: 'tarefa-2',
    tarefa_titulo: 'Análise de dados de vendas',
    usuario_origem_id: 'user-2',
    usuario_origem_nome: 'Maria Silva',
    usuario_origem_avatar: '/profilepicture.png', // Usando imagem padrão
    data_hora: new Date(Date.now() - 7200000).toISOString(), // 2 horas atrás
    lida: true
  },
  {
    id: 'ativ-3',
    tipo: 'mudanca_status',
    titulo: 'Status alterado',
    descricao: 'O status da tarefa foi alterado para Em Andamento',
    tarefa_id: 'tarefa-3',
    tarefa_titulo: 'Preparação de apresentação',
    usuario_origem_id: 'user-3',
    usuario_origem_nome: 'Carlos Mendes',
    usuario_origem_avatar: '/profilepicture.png', // Usando imagem padrão
    data_hora: new Date(Date.now() - 86400000).toISOString(), // 1 dia atrás
    lida: false,
    status_anterior: 'Pendente',
    status_novo: 'Em Andamento'
  },
  {
    id: 'ativ-4',
    tipo: 'aprovacao_solicitada',
    titulo: 'Aprovação solicitada',
    descricao: 'Carlos solicitou sua aprovação para a tarefa: Orçamento trimestral',
    tarefa_id: 'tarefa-4',
    tarefa_titulo: 'Orçamento trimestral',
    usuario_origem_id: 'user-3',
    usuario_origem_nome: 'Carlos Mendes',
    usuario_origem_avatar: '/profilepicture.png', // Usando imagem padrão
    data_hora: new Date(Date.now() - 172800000).toISOString(), // 2 dias atrás
    lida: true
  },
  {
    id: 'ativ-5',
    tipo: 'prazo_proximo',
    titulo: 'Prazo se aproximando',
    descricao: 'A tarefa "Revisão de contratos" vence em 24 horas',
    tarefa_id: 'tarefa-5',
    tarefa_titulo: 'Revisão de contratos',
    data_hora: new Date(Date.now() - 259200000).toISOString(), // 3 dias atrás
    lida: false
  }
];
